<template>
    <div>
        <h2>เพิ่มวันหยุดนักขัตฤกษ์</h2>
        <b-row>
            <b-col sm="4" class="col-sm-4 text-right">วันหยุด</b-col>
            <b-col sm="6" class="col-sm-6">
                <input class="form-control" v-model="form.name"/>
            </b-col>
        </b-row>
        <br/>
        <b-row>
            <b-col sm="4" class="col-sm-4 text-right">วันที่วันหยุด</b-col>
            <b-col sm="6" class="col-sm-6">
                <date-picker
                        v-model="form.start_date"
                        class="w-100"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่เริ่มต้น">
                </date-picker>
            </b-col>
        </b-row>
        <br>
        <div class="col text-center">
            <button type="button"
                    @click="submitHoliday"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก</button>&nbsp&nbsp
            <button type="button"
                    @click="cancelHoliday"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
        <!--<pre class="alert alert-danger text-left">{{form}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import DatePicker from 'vue2-datepicker'
import moment from "moment"

export default {
        name: "holiday-modal",
        components: {
            DatePicker
        },
        created(){
            if(!this.form.id){
                this.$store.dispatch("Holiday/clearData");
            }
        },
        data(){
            return {
                changeFormat: {
                    stringify: (date) => {
                        if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        computed:{
            ...mapState({
                form:state=>{
                    return state.Holiday.holidayForm
                },
                user : state=>{
                    return state.Auth.user;
                }
            })
        },
        methods:{
            submitHoliday(){
                if(!this.form.name){
                    alert("กรุณาใส่ชื่อ")
                }
                else if(!this.form.start_date){
                    alert("กรุณาใส่วันที่")
                }
                else{
                    this.form.start_date = moment(this.form.start_date).format('YYYY-MM-DD');
                    this.form.end_date = moment(this.form.end_date).format('YYYY-MM-DD');
                    this.form.user_id = this.user.id;
                    this.$emit("submit",this.form)
                    this.$store.dispatch("Holiday/clearData");
                }
            },
            cancelHoliday(){
                this.$emit("submit",0);
                this.$store.dispatch("Holiday/clearData");
            }
        }
    }
</script>

<style scoped>

</style>
